import { connect } from 'react-redux';
import CrackStock from './CrackStock';
import { withRouter } from 'react-router';

const mapStateToProps = (state, ownProps) => {
    let stores = state.dashboardBrandReducer.stores || [];
    const value = {
        stores: stores,
        isFetching: state.dashboardBrandReducer.isFetching
    };
    return value;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
    };
};

export const CrackStockConnected = connect(mapStateToProps, mapDispatchToProps)(CrackStock);
export default withRouter(CrackStockConnected);